import { useEffect } from 'react';
import { useCheckoutState } from '../../utils/checkoutState';
import { config } from '../../utils/config';
import Modal from '../atoms/Modal';

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    wpwlOptions?: { locale?: string };
  }
}

type ArvatoPaymentProps = {
  onClose: () => void;
};

// https://arvato.docs.oppwa.com/tutorials/integration-guide

const ArvatoPayment = ({ onClose }: ArvatoPaymentProps) => {
  const { checkoutState } = useCheckoutState();
  const initializationData = checkoutState.orderConfirmation?.initializationData;
  const action = checkoutState.orderConfirmation?.redirect?.url;
  const dataBrands = initializationData?.paymentBrand.join(' ');
  const checkoutId = initializationData?.sessionId;

  useEffect(() => {
    window.wpwlOptions = { locale: config.locale.substring(0, 2) };

    if (IS_WEB_COMPONENT) {
      const arvatoPaymentContainer = document.getElementById('arvato-payment-container');
      const form = document.createElement('form');
      form.action = action!;
      form.className = 'paymentWidgets';
      form.setAttribute('data-brands', dataBrands);
      arvatoPaymentContainer?.appendChild(form);
    }

    const script = document.createElement('script');
    const arvatoSdkHost = config.isProduction ? 'oppwa.com' : 'test.oppwa.com';
    script.src = `https://${arvatoSdkHost}/v1/paymentWidgets.js?checkoutId=${checkoutId}`;
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
      delete window.wpwlOptions;

      if (IS_WEB_COMPONENT) {
        const arvatoPaymentContainer = document.getElementById('arvato-payment-container');
        if (arvatoPaymentContainer) {
          arvatoPaymentContainer.innerHTML = '';
        }
      }
    };
  }, []);

  return (
    <Modal onClose={onClose}>
      {IS_WEB_COMPONENT ? (
        <slot name="arvato-payment-container" />
      ) : (
        <form action={action} className="paymentWidgets" data-brands={dataBrands} />
      )}
    </Modal>
  );
};

export default ArvatoPayment;
